"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.archive = void 0;
/* eslint-disable max-len */

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var archive = function archive(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'archive-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M2.25 5.5C2.25 4.5335 3.0335 3.75 4 3.75H16C16.9665 3.75 17.75 4.5335 17.75 5.5V7.75H2.25V5.5ZM4 5.25C3.86193 5.25 3.75 5.36193 3.75 5.5V6.25H16.25V5.5C16.25 5.36193 16.1381 5.25 16 5.25H4ZM3.25 14.5V8.5H4.75V14.5C4.75 14.9142 5.08579 15.25 5.5 15.25H14.5C14.9142 15.25 15.25 14.9142 15.25 14.5V8.5H16.75V14.5C16.75 15.7426 15.7426 16.75 14.5 16.75H5.5C4.25736 16.75 3.25 15.7426 3.25 14.5ZM7.5 11.25C7.5 10.8358 7.83579 10.5 8.25 10.5H11.75C12.1642 10.5 12.5 10.8358 12.5 11.25C12.5 11.6642 12.1642 12 11.75 12H8.25C7.83579 12 7.5 11.6642 7.5 11.25Z',
    fill: '#4B5563'
  }));
};

exports.archive = archive;